import licenseTypes from 'data/LicenseTypes/licenseTypes';

const { licenses } = licenseTypes;

// eslint-disable-next-line import/prefer-default-export
export default function getStateLicenseType(RegionId) {
  // AK : 3
  const statesWithDifferentBehavior = [3];
  const license =  licenses.find(l => l.RegionId == RegionId);
  
  if(license){
    if (statesWithDifferentBehavior.includes(RegionId) && sessionStorage.IsProducer === 'false') {
      return { ...license, LicenseName: 'No License Required', NoLicenseRequired: true };
    }
    return license;
  }
}